import { DateTime } from "luxon"

export const getTripOverviewDates = (days: number) => {
  const start = DateTime.now().setZone("America/Chicago").startOf("day").minus({ days: days })

  const dateArr: Date[] = []

  for (let i = 0; i < days; i++) {
    const current = start.plus({ days: i })
    dateArr.push(current.toJSDate() || new Date())
  }

  return dateArr
}
